const actions = {
  SET_STATE: 'widget/SET_STATE',
  GET_WEBSITE_WIDGET: 'widget/GET_WEBSITE_WIDGET',
  GET_WIDGET_SCRIPT: 'widget/GET_WIDGET_SCRIPT',
  UPDATE_WEBSITE_WIDGET: 'widget/UPDATE_WEBSITE_WIDGET',
}

export default actions
